import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Grid, Table, Alert, Snackbar, tableCellClasses, Button, TextField, IconButton, InputLabel, Select, MenuItem, FormHelperText, FormControl } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { fetchCustomerSupportRemovalTransfers, createCustomerSupportRemovalTransfer, updateCustomerSupportRemovalTransfer, deleteCustomerSupportRemovalTransfer, emailCustomerSupportRemovalTransferPdf, fetchCustomers, fetchSolutions, fetchVehicles, fetchImeiAttach } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';
import { z } from "zod";
import { FormModal, RHFTextField, RHFSelect } from "../components/form";
import { Controller, useFormContext } from "react-hook-form";

export function CustomerSupportRemovalTransfer() {
  const [haulierOptions, setHaulierOptions] = React.useState([]);
  const [truckOptions, setTruckOptions] = React.useState([]);
  const [devicesOptions, setDevicesOptions] = React.useState([]);
  const [sendingEmailId, setSendingEmailId] = React.useState(null);
  const [vehicleData, setVehicleData] = React.useState([]);
  const [imeiData, setIMEIData] = React.useState([]);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
  const [modalOpen, setModalOpen] = React.useState(false);
  const [searchVehicle, setSearchVehicle] = React.useState('');
const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);
  const fetchTrucks = async () => {
    try {
      const response = await fetchCustomerSupportRemovalTransfers();
      setCustomerSupportRemovalTransferData(response.data);
      showSnackbar('Customer Support Removal/Transfer fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching Customer Support Data';
      showSnackbar(`Failed to fetch Customer Support Data: ${errorMessage}`, 'error');
    }
  };

  const fetchHauliers = async () => {
    try {
      const response = await fetchCustomers();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setHaulierOptions(haulierDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchDevices = async () => {
    try {
      const response = await fetchSolutions();
      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setDevicesOptions(deviceDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchTruck = async () => {
    try {
      const response = await fetchVehicles();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.registration_number;
        return acc;
      }, {});
      setTruckOptions(haulierDict)
      setVehicleData(response.data)

      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const fetchIMEIAttach = async () => {
    try {
      const response = await fetchImeiAttach();
      console.log(response.data);
      setIMEIData(response.data)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const handleSendEmail = async (saleId) => {
    setSendingEmailId(saleId);

    try {
      await emailCustomerSupportRemovalTransferPdf(saleId, {});
      alert("Email sent successfully!");
    } catch (error) {
      console.error("Email error:", error);
      alert("Failed to send email.");
    } finally {
      setSendingEmailId(null);
    }
  };

  React.useEffect(() => {
    fetchTrucks();
    fetchHauliers();
    fetchDevices();
    fetchTruck();
    fetchIMEIAttach()
  }, []);

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const [customerSupportData, setCustomerSupportRemovalTransferData] = React.useState([])
  // Save customerSupportData to localStorage on update
  React.useEffect(() => {
    localStorage.setItem('customerSupport', JSON.stringify(customerSupportData));
    console.log(customerSupportData, 'customerSupportData');

  }, [customerSupportData]);
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [selectedCustomerSupportRemovalTransfer, setSelectedCustomerSupportRemovalTransfer] = React.useState(null);
  const handleEditOn = (device) => {
    setSelectedCustomerSupportRemovalTransfer(device);
    setEditModalOpen(true);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setSelectedCustomerSupportRemovalTransfer(null);
  };
  const handleDelete = async (id) => {
    try {
      await deleteCustomerSupportRemovalTransfer(id);
      showSnackbar("Customer deleted successfully", "success");
    } catch (error) {
      showSnackbar("Failed to delete customer", "error");
      console.error(error);
    }
  };
  const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a3');

  // Title
  doc.setFontSize(18);
  doc.text('Customer Support Removal/Transfer Report', 14, 16);

  // Match table headers
  const columns = [
    'Rem/Tran #',
    'Customer',
    'Removal Vehicle No',
    'Transfer Vehicle No',
    'Solution',
    'Features',
    'Corporate',
    'POC Name',
    'POC Contact',
    'Description',
    'Remarks',
    'Technical Status',
    'Collection Recovery Status',
    'Document',
  ];

  // Map table rows
  const tableData = customerSupportData.map(record => [
    record.id,
    haulierOptions[record.customer] || "",
    truckOptions[record.removal_vehicle_number] || "",
    truckOptions[record.transfer_vehicle_number] || "",
    devicesOptions[record.solution] || "",
    record.features,
    record.corporate,
    record.poc_name,
    record.poc_contact,
    record.description,
    record.remarks,
    record.technical_status,
    record.sales_coordinator_status,
    record.document_url ? "Available" : "Not Available",
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 2,
    },
    columnStyles: {
      0: { cellWidth: 25 },  // Rem/Tran #
      1: { cellWidth: 40 },  // Customer
      2: { cellWidth: 40 },  // Removal Vehicle
      3: { cellWidth: 40 },  // Transfer Vehicle
      4: { cellWidth: 30 },  // Solution
      5: { cellWidth: 40 },  // Features
      6: { cellWidth: 30 },  // Corporate
      7: { cellWidth: 40 },  // POC Name
      8: { cellWidth: 40 },  // POC Contact
      9: { cellWidth: 50 },  // Description
      10: { cellWidth: 50 }, // Remarks
      11: { cellWidth: 40 }, // Technical Status
      12: { cellWidth: 40 }, // Collection Recovery Status
      13: { cellWidth: 40 }, // Document
    },
    theme: 'grid',
    didDrawPage: () => {
      doc.setFontSize(18);
      doc.text('Customer Support Removal/Transfer Report', 14, 16);
    },
  });

  doc.save('Customer_Support_Removal_Transfer_Report.pdf');
};
  const updateCustomerSupportRemovalTransferData = async (updatedData, id) => {
    const formData = new FormData();
    for (const key in updatedData) {
      formData.append(key, updatedData[key]);
    }
    try {
      await updateCustomerSupportRemovalTransfer(id, formData);
      showSnackbar('Customer Support Removal/Transfer updated successfully', 'success');
    } catch (error) {
      showSnackbar('Failed to update device', 'error');
    }
  };
  const handleStatusChange = async (saleId, newStatus, sale) => {
    const updatedSale = { ...sale, status: newStatus };

    try {
      await updateCustomerSupportRemovalTransfer(saleId, updatedSale);

      // Update state in frontend
      setCustomerSupportRemovalTransferData((prevData) =>
        prevData.map((item) =>
          item.id === saleId ? { ...item, status: newStatus } : item
        )
      );

      showSnackbar('Status updated successfully', 'success');
    } catch (error) {
      console.error('Failed to update status:', error);
      showSnackbar('Failed to update status', 'error');
    }
  };
  const filteredCustomerSupportData = searchVehicle
    ? customerSupportData.filter((sale) =>
      truckOptions[sale.vehicle_details?.id]
        ?.toLowerCase()
        .includes(searchVehicle.toLowerCase())
    )
    : customerSupportData;
  return (
    <Container maxWidth="xl" sx={{ m: 2 }}>
      <AddCustomerSupportRemovalTransferModal
        open={modalOpen}
        handleClose={handleClose}
        showSnackbar={showSnackbar}
        fetchComplains={fetchTrucks}
        haulierOptions={haulierOptions}
        truckOptions={truckOptions}
        devicesOptions={devicesOptions}
        vehicleData={vehicleData}
        imeiData={imeiData}
      />
      {editModalOpen && selectedCustomerSupportRemovalTransfer && <EditCustomerSupportRemovalTransferModal
        open={editModalOpen}
        handleClose={handleEditClose}
        device={selectedCustomerSupportRemovalTransfer}
        devicesOptions={devicesOptions}
        haulierOptions={haulierOptions}
        truckOptions={truckOptions}
        showSnackbar={showSnackbar}
        fetchTrucks={fetchTrucks}
      />}
      <DataTable
        title="Customer Support Removal/Transfer List"
        columns={[
          { key: 'id', label: 'Rem/Tran #' },
          { key: 'customer', label: 'Customer', render: (complain) => haulierOptions[complain.customer] },
          { key: 'removal_vehicle_number', label: 'Removal Vehicle No', render: (complain) => truckOptions[complain.removal_vehicle_number] },
          { key: 'transfer_vehicle_number', label: 'Transfer Vehicle No', render: (complain) => truckOptions[complain.transfer_vehicle_number] },
          { key: 'solution', label: 'Solution', render: (complain) => devicesOptions[complain.solution] },
          { key: 'features', label: 'Features' },
          { key: 'corporate', label: 'Corporate' },
          { key: 'poc_name', label: 'POC Name' },
          { key: 'poc_contact', label: 'POC contact' },
          { key: 'description', label: 'Description' },
          { key: 'remarks', label: 'Remarks', render: (complain) => <div style={{ maxHeight: '80px', overflow: 'auto' }}>{complain.remarks}</div> },
          { key: 'technical_status', label: 'Technical Status', render: (complain) => <div style={{ maxHeight: '80px', overflow: 'auto' }}>{complain.technical_status}</div> },
          { key: 'sales_coordinator_status', label: 'Collection Recovery Status', render: (complain) => <div style={{ maxHeight: '80px', overflow: 'auto' }}>{complain.sales_coordinator_status}</div> },
          { key: 'document_url', label: 'Document', render: (complain) => complain.document_url ? (
            <a href={`https://crm-backend.monit.tech/${complain.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a>
          ) : <span style={{ color: '#999' }}>Not Available</span> },
        ]}
        rows={filteredCustomerSupportData}
        toolbarActions={<>
          <TextField size="small" placeholder="Search Vehicle..." value={searchVehicle} onChange={(e) => setSearchVehicle(e.target.value)} />
          <Button variant="contained" color="primary" onClick={handleOpen}>Add Customer Removal/Transfer</Button>
          <Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>
        </>}
        renderActions={(complain) => <>
          <IconButton color="secondary" size="small" onClick={() => handleEditOn(complain)} sx={{ padding: '6px' }} disabled={complain.status === 'Closed'}><EditIcon /></IconButton>
          <IconButton color="error" size="small" onClick={() => handleDeleteClick(complain.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={complain.status === 'Complete'}><DeleteIcon /></IconButton>
          <IconButton color="primary" size="small" onClick={() => handleSendClick(complain.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === complain.id}>
            {sendingEmailId === complain.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          </IconButton>
          <Select value={complain.status} onChange={(e) => handleStatusChange(complain.id, e.target.value, complain)} size="small" sx={{ ml: 1, minWidth: 100 }}>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="In Progress">In Progress</MenuItem>
            <MenuItem value="Resolved">Resolved</MenuItem>
            <MenuItem value="Complete">Complete</MenuItem>
          </Select>
        </>}
      />
          {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}

// ---------------------------------------------------------------------------
// Shared Zod schema
// ---------------------------------------------------------------------------

const csrtSchema = z.object({
  description: z.string().optional(),
  customer: z.string().min(1, "Required"),
  removal_vehicle_number: z.string().min(1, "Required"),
  transfer_vehicle_number: z.string().optional(),
  solution: z.string().optional(),
  features: z.string().optional(),
  poc_name: z.string().min(1, "Required"),
  poc_contact: z.string().min(1, "Required"),
  corporate: z.string().optional(),
  location: z.string().optional(),
  remarks: z.string().optional(),
}).superRefine((d, ctx) => {
  if (d.description !== "Removal" && !d.transfer_vehicle_number) {
    ctx.addIssue({
      path: ["transfer_vehicle_number"],
      message: "Required for Transfer/Removal & Transfer",
      code: "custom",
    });
  }
});

// ---------------------------------------------------------------------------
// Watches the customer field inside FormProvider; loads trucks when it changes.
// Resets removal_vehicle_number on subsequent customer changes (not on initial open).
// ---------------------------------------------------------------------------

const CustomerTruckWatcher = ({ setTrucks, open }) => {
  const { watch, setValue } = useFormContext();
  const customer = watch("customer");
  const prevRef = React.useRef(undefined);

  React.useEffect(() => {
    if (!open) {
      prevRef.current = undefined;
      return;
    }
    if (!customer) return;
    const isFirstLoad = prevRef.current === undefined;
    prevRef.current = customer;
    fetchVehicles(customer)
      .then((res) => {
        setTrucks(
          res.data.reduce((acc, item) => ({ ...acc, [item.id]: item.registration_number }), {})
        );
        if (!isFirstLoad) {
          setValue("removal_vehicle_number", "");
        }
      })
      .catch(console.error);
  }, [customer, open]);

  return null;
};

// ---------------------------------------------------------------------------
// Edit modal
// ---------------------------------------------------------------------------

const EditCustomerSupportRemovalTransferModal = ({
  open,
  handleClose,
  device,
  showSnackbar,
  fetchTrucks,
  haulierOptions,
}) => {
  const [trucks, setTrucks] = React.useState({});

  return (
    <FormModal
      open={open}
      onClose={handleClose}
      title="Edit Customer Support Removal/Transfer"
      schema={csrtSchema}
      defaultValues={{
        description: device?.description || "",
        customer: device?.customer ? String(device.customer) : "",
        removal_vehicle_number: device?.removal_vehicle_number ? String(device.removal_vehicle_number) : "",
        transfer_vehicle_number: device?.transfer_vehicle_number ? String(device.transfer_vehicle_number) : "",
        solution: device?.solution || "",
        features: device?.features || "",
        poc_name: device?.poc_name || "",
        poc_contact: device?.poc_contact || "",
        corporate: device?.corporate || "",
        location: device?.location || "",
        remarks: device?.remarks || "",
      }}
      onSubmit={async (data) => {
        const fd = new FormData();
        Object.entries(data).forEach(([k, v]) => {
          if (v !== null && v !== undefined && v !== "") fd.append(k, v);
        });
        try {
          await updateCustomerSupportRemovalTransfer(device.id, fd);
          showSnackbar("Customer Support Removal/Transfer updated successfully", "success");
          fetchTrucks();
        } catch (error) {
          showSnackbar("Failed to update device", "error");
          throw error;
        }
      }}
      submitLabel="Update"
      width={620}
    >
      {({ control, watch }) => {
        const description = watch("description");
        return (
          <>
            <CustomerTruckWatcher setTrucks={setTrucks} open={open} />
            <Grid container spacing={2.5}>
              <Grid item xs={12} md={6}>
                <RHFSelect control={control} name="description" label="Description">
                  <MenuItem value="">—</MenuItem>
                  <MenuItem value="Removal">Removal</MenuItem>
                  <MenuItem value="Transfer">Transfer</MenuItem>
                  <MenuItem value="Removal & Transfer">Removal & Transfer</MenuItem>
                </RHFSelect>
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFSelect control={control} name="customer" label="Contractor" options={haulierOptions} required />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFSelect control={control} name="removal_vehicle_number" label="Removal Vehicle Number" options={trucks} required />
              </Grid>

              {description !== "Removal" && (
                <Grid item xs={12} md={6}>
                  <RHFSelect control={control} name="transfer_vehicle_number" label="Transfer Vehicle Number" options={trucks} required />
                </Grid>
              )}

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="solution" label="Solution" disabled />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="features" label="Features" disabled />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="poc_name" label="POC Name" required />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="poc_contact" label="POC Contact" required />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="corporate" label="Corporate" />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="location" label="Location" />
              </Grid>

              <Grid item xs={12}>
                <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={2} />
              </Grid>
            </Grid>
          </>
        );
      }}
    </FormModal>
  );
};

// ---------------------------------------------------------------------------
// Add modal
// ---------------------------------------------------------------------------

const AddCustomerSupportRemovalTransferModal = ({
  open,
  handleClose,
  showSnackbar,
  fetchComplains,
  haulierOptions,
  imeiData,
  vehicleData,
  devicesOptions,
}) => {
  const [trucks, setTrucks] = React.useState({});

  return (
    <FormModal
      open={open}
      onClose={handleClose}
      title="Add Customer Support Removal/Transfer"
      schema={csrtSchema}
      defaultValues={{
        description: "",
        customer: "",
        removal_vehicle_number: "",
        transfer_vehicle_number: "",
        solution: "",
        features: "",
        poc_name: "",
        poc_contact: "",
        corporate: "",
        location: "",
        remarks: "",
      }}
      onSubmit={async (data) => {
        const fd = new FormData();
        Object.entries(data).forEach(([k, v]) => {
          if (v !== null && v !== undefined && v !== "") fd.append(k, v);
        });
        try {
          await createCustomerSupportRemovalTransfer(fd);
          showSnackbar("Customer Support Removal/Transfer added successfully", "success");
          fetchComplains();
        } catch (error) {
          showSnackbar("Failed to add record", "error");
          throw error;
        }
      }}
      submitLabel="Add"
      width={620}
    >
      {({ control, watch, setValue }) => {
        const description = watch("description");
        return (
          <>
            <CustomerTruckWatcher setTrucks={setTrucks} open={open} />
            <Grid container spacing={2.5}>
              <Grid item xs={12} md={6}>
                <RHFSelect control={control} name="description" label="Description">
                  <MenuItem value="">—</MenuItem>
                  <MenuItem value="Removal">Removal</MenuItem>
                  <MenuItem value="Transfer">Transfer</MenuItem>
                  <MenuItem value="Removal & Transfer">Removal & Transfer</MenuItem>
                </RHFSelect>
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFSelect control={control} name="customer" label="Contractor" options={haulierOptions} required />
              </Grid>

              <Grid item xs={12} md={6}>
                <Controller
                  control={control}
                  name="removal_vehicle_number"
                  render={({ field, fieldState }) => (
                    <FormControl fullWidth required error={!!fieldState.error}>
                      <InputLabel>Removal Vehicle Number</InputLabel>
                      <Select
                        {...field}
                        label="Removal Vehicle Number"
                        value={field.value ?? ""}
                        onChange={(e) => {
                          field.onChange(e);
                          const match = imeiData.find(
                            (d) => d.vehicle === parseInt(e.target.value)
                          );
                          setValue("solution", match?.solution_display || "");
                          setValue("features", match?.features_display || "");
                        }}
                      >
                        {Object.entries(trucks).map(([k, v]) => (
                          <MenuItem key={k} value={String(k)}>{v}</MenuItem>
                        ))}
                      </Select>
                      {fieldState.error && (
                        <FormHelperText>{fieldState.error.message}</FormHelperText>
                      )}
                    </FormControl>
                  )}
                />
              </Grid>

              {description !== "Removal" && (
                <Grid item xs={12} md={6}>
                  <RHFSelect control={control} name="transfer_vehicle_number" label="Transfer Vehicle Number" options={trucks} required />
                </Grid>
              )}

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="solution" label="Solution" disabled />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="features" label="Features" disabled />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="poc_name" label="POC Name" required />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="poc_contact" label="POC Contact" required />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="corporate" label="Corporate" />
              </Grid>

              <Grid item xs={12} md={6}>
                <RHFTextField control={control} name="location" label="Location" />
              </Grid>

              <Grid item xs={12}>
                <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={2} />
              </Grid>
            </Grid>
          </>
        );
      }}
    </FormModal>
  );
};

export { EditCustomerSupportRemovalTransferModal, AddCustomerSupportRemovalTransferModal };
